export default __webpack_public_path__ + "static/media/medium.e94a1f26.svg";